module.exports = __webpack_public_path__ + "static/media/tokens.f27215b5.png";